import { useState } from 'react';
import { Outlet, useMatches } from 'react-router-dom';

import { DialogHost } from '@/components/feedback/dialog';
import type { RouteHandle } from '@/types';

import { PageContainer } from '../page-container';
import { TopNav } from '../top-nav';

import styles from './app-shell.module.scss';
import { HeaderSlotContext } from './header-slot';

export function AppShell() {
  // D-01: a map surface's route `handle` (see `RouteHandle`) opts out of the standard chrome —
  // <TopNav> floats over an edge-to-edge canvas instead of sitting above a <PageContainer>. `some`,
  // not the leaf match alone, because `useMatches()` returns the whole matched branch and only the
  // page route itself carries the handle.
  const matches = useMatches();
  const fullBleed = matches.some((match) => (match.handle as RouteHandle | undefined)?.fullBleed);

  // The header slot element, held here rather than in <TopNav> because pages
  // render below it in the tree. Callback ref — no effect, no double render.
  const [headerSlot, setHeaderSlot] = useState<HTMLDivElement | null>(null);

  return (
    <DialogHost>
      <div className={styles.shell}>
        <TopNav slotRef={setHeaderSlot} floating={fullBleed} />
        <main className={fullBleed ? styles.fullBleedContent : styles.content}>
          <HeaderSlotContext.Provider value={headerSlot}>
            {fullBleed ? (
              <Outlet />
            ) : (
              <PageContainer>
                <Outlet />
              </PageContainer>
            )}
          </HeaderSlotContext.Provider>
        </main>
      </div>
      {/* Web push (ADR-0020). Renders nothing — it configures FCM from the env, listens, and
          lets a foreground message toast. No-ops when the Firebase env vars are unset. */}
    </DialogHost>
  );
}
